import { render } from "./SoftInputModel.vue?vue&type=template&id=664c3d07&scoped=true"
import script from "./SoftInputModel.vue?vue&type=script&lang=js"
export * from "./SoftInputModel.vue?vue&type=script&lang=js"

import "./SoftInputModel.vue?vue&type=style&index=0&id=664c3d07&scoped=true&lang=css"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664c3d07"]])

export default __exports__